import { call, put, all, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "constants/api";

import {
  GET_EMPLOYEE_CATEGORIES,
  SG_GET_EMPLOYEE_CATEGORIES,
  DELETE_EMPLOYEE_CATEGORY,
  SG_DELETE_EMPLOYEE_CATEGORY,
  FETCH_EMPLOYEE_CATEGORY,
  SG_FETCH_EMPLOYEE_CATEGORY,
  EDIT_EMPLOYEE_CATEGORY,
  SG_EDIT_EMPLOYEE_CATEGORY,
  ADD_EMPLOYEE_CATEGORY,
  SG_ADD_EMPLOYEE_CATEGORY,
  CLEAR_EMPLOYEE_CATEGORY,
  SG_GET_EMPLOYEE_ORG_CATEGORIES,
  GET_EMPLOYEE_ORG_CATEGORIES,
  SG_GET_EMPLOYEE_ORG_CATEGORIES_BY_FIRST_NAME,
  GET_EMPLOYEE_ORG_CATEGORIES_BY_FIRST_NAME,
  ALL_ERRORS,
  GET_EMPLOYEE_USER_CATEGORIES,
  SG_GET_EMPLOYEE_USER_CATEGORIES,
  SG_EMPLOYEE_CATEGORY_SEARCH,
  EMPLOYEE_CATEGORY_SEARCH_PENDING,
  EMPLOYEE_CATEGORY_SEARCH_SUCCESS,
  EMPLOYEE_CATEGORY_SEARCH_FAILURE,
} from "constants/actions";

function* loadmethods(action) {
  //   yield put({ type: GET_methodS_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_EMPLOYEE_CATEGORIES, action.payload);
    yield put({ type: GET_EMPLOYEE_CATEGORIES, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_EMPLOYEE_CATEGORIES, loadmethods);
}

function* fetchmethods(action) {
  try {
    const json = yield call(api.FETCH_EMPLOYEE_CATEGORY, action.payload);
    yield put({ type: FETCH_EMPLOYEE_CATEGORY, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_EMPLOYEE_CATEGORY, fetchmethods);
}

function* updatemethods(action) {
  try {
    const json = yield call(api.EDIT_EMPLOYEE_CATEGORY, action.payload);
    yield put({ type: EDIT_EMPLOYEE_CATEGORY, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodUpdate() {
  yield takeEvery(SG_EDIT_EMPLOYEE_CATEGORY, updatemethods);
}

function* addmethods(action) {
  try {
    const json = yield call(api.ADD_EMPLOYEE_CATEGORY, action.payload);
    yield put({ type: ADD_EMPLOYEE_CATEGORY, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_EMPLOYEE_CATEGORY, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_EMPLOYEE_CATEGORY, action.payload);
    yield put({ type: DELETE_EMPLOYEE_CATEGORY, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_EMPLOYEE_CATEGORY, deletemethods);
}

function* getOrgCategories(action) {
  try {
    // Check if we should fetch all pages
    const shouldFetchAll = action.payload?.fetchAllPages === true;

    if (!shouldFetchAll) {
    // Original behavior for non-fetchAll requests
      const json = yield call(api.GET_EMPLOYEE_CATEGORIES, action.payload);
      yield put({ type: GET_EMPLOYEE_ORG_CATEGORIES, payload: json.data });
      return;
    }

    // Multi-page fetch logic
    let payload = action.payload;

    // Convert string payload to object if needed
    if (typeof payload === 'string') {
      const params = new URLSearchParams(payload);
      payload = Object.fromEntries(params.entries());
    }

    // Remove fetchAllPages flag and set page_size to 100
    const { fetchAllPages, ...queryParams } = payload;
    queryParams.page_size = 100;
    queryParams.page = 1;

    // Fetch first page
    const firstResponse = yield call(api.GET_EMPLOYEE_CATEGORIES, queryParams);
    const firstData = firstResponse.data;

    let allResults = [...(firstData.results || [])];
    const count = firstData.count || 0;
    // Use the page_size we requested, not what the API returns
    const pageSize = queryParams.page_size;
    const totalPages = Math.ceil(count / pageSize);

    // Fetch remaining pages if needed
    if (totalPages > 1) {
      for (let page = 2; page <= totalPages; page++) {
        const pageResponse = yield call(api.GET_EMPLOYEE_CATEGORIES, {
          ...queryParams,
          page,
        });
        const pageData = pageResponse.data;
        const pageResults = pageData.results || [];
        allResults = allResults.concat(pageResults);
      }
    }

    // Dispatch merged results
    yield put({
      type: GET_EMPLOYEE_ORG_CATEGORIES,
      payload: {
        ...firstData,
        results: allResults,
        count: allResults.length,
        links: {
          next: null,
          previous: null,
        },
      },
    });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodGetOrgCategories() {
  yield takeLatest(SG_GET_EMPLOYEE_ORG_CATEGORIES, getOrgCategories);
}

function* getUserCategories(action) {
  try {
    const json = yield call(api.GET_EMPLOYEE_CATEGORIES, action.payload);
    yield put({ type: GET_EMPLOYEE_USER_CATEGORIES, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodGetUserCategories() {
  yield takeLatest(SG_GET_EMPLOYEE_USER_CATEGORIES, getUserCategories);
}

function* getOrgCategoriesByFirstName(action) {
  try {
    const json = yield call(api.GET_EMPLOYEE_CATEGORIES, action.payload);
    yield put({ type: GET_EMPLOYEE_ORG_CATEGORIES_BY_FIRST_NAME, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodGetOrgCategoriesByFirstName() {
  yield takeLatest(SG_GET_EMPLOYEE_ORG_CATEGORIES_BY_FIRST_NAME, getOrgCategoriesByFirstName);
}

function* searchEmployeeCategories(action) {
  const {
    page = 1,
    page_size = 50,
    ordering,
    employee,
    category_name,
    category_value,
    category_name_id,
    category_value_id,
    category_priority,
  } = action.payload || {};
  // Separate "filters" (for the reducer) from pagination/ordering
  const filters = {
    employee,
    category_name,
    category_value,
    category_name_id,
    category_value_id,
    category_priority,
  };
  try {
    yield put({ type: EMPLOYEE_CATEGORY_SEARCH_PENDING });
    const queryParams = {
      page,
      page_size,
      // Only pass ordering if defined
      ...(ordering ? { ordering } : {}),
      // Filters (only those that are defined)
      ...(employee !== undefined && employee !== null ? { employee } : {}),
      ...(category_name ? { category_name } : {}),
      ...(category_value ? { category_value } : {}),
      ...(category_name_id ? { category_name_id } : {}),
      ...(category_value_id ? { category_value_id } : {}),
      ...(category_priority ? { category_priority } : {}),
    };
    const response = yield call(api.GET_EMPLOYEE_CATEGORIES, queryParams);
    const data = response?.data || {};
    yield put({
      type: EMPLOYEE_CATEGORY_SEARCH_SUCCESS,
      payload: {
        data,
        filters,
        ordering: ordering || null,
        page,
        page_size,
      },
    });
  } catch (error) {
    console.error("❌ SAGA: EmployeeCategory search failed", error);
    yield put({
      type: EMPLOYEE_CATEGORY_SEARCH_FAILURE,
      payload: error?.message || "Unable to fetch employee categories",
    });
  }
}

export function* methodSearchEmployeeCategories() {
  yield takeLatest(SG_EMPLOYEE_CATEGORY_SEARCH, searchEmployeeCategories);
}

export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
    methodGetOrgCategories(),
    methodGetOrgCategoriesByFirstName(),
    methodGetUserCategories(),
    methodSearchEmployeeCategories(),
  ]);
}
